// Catalogo de funcionalidades (menus / sub-menus) controlaveis pela tela
// "Controle de Acesso" (v44). A `key` de cada no e EXATAMENTE o `name` usado
// na Sidebar.vue -> permite esconder o item do menu. `routes` lista os route
// names da funcionalidade -> permite o guard (routeHelpers.js) bloquear o
// acesso por URL.
//
// Itens DINAMICOS (etiquetas, times, pastas, segmentos, empresas individuais)
// NAO entram aqui: sao gerados a partir de dados e nunca sao bloqueados
// individualmente por esta tela.
//
// EXCECAO (v13): os TIPOS DE CANAL entram, porque sao uma lista fixa de codigo
// (nao vem do banco) e o Kairo precisa definir quem pode criar cada tipo de
// caixa. Ficam como filhos de "Settings Inboxes".

// Prefixo das keys de canal. Mantido junto do catalogo para ChannelList e
// ChannelFactory montarem a mesma key sem duplicar string solta.
export const CHANNEL_KEY_PREFIX = 'Settings Inboxes Channel ';
export const channelFeatureKey = channelKey =>
  `${CHANNEL_KEY_PREFIX}${channelKey}`;

// A ordem e os rotulos acompanham os cards da tela de criar caixa.
const CHANNEL_KEYS = [
  { key: channelFeatureKey('mazamweb'), label: 'SITE WEB' },
  { key: channelFeatureKey('website'), label: 'Site (widget)' },
  { key: channelFeatureKey('whatsapp'), label: 'WhatsApp' },
  { key: channelFeatureKey('infobip'), label: 'Infobip' },
  { key: channelFeatureKey('facebook'), label: 'Facebook' },
  { key: channelFeatureKey('instagram'), label: 'Instagram' },
  { key: channelFeatureKey('telegram'), label: 'Telegram' },
  { key: channelFeatureKey('sms'), label: 'SMS' },
  { key: channelFeatureKey('email'), label: 'E-Mail' },
  { key: channelFeatureKey('api'), label: 'API' },
  { key: channelFeatureKey('line'), label: 'Line' },
  { key: channelFeatureKey('tiktok'), label: 'TikTok' },
  { key: channelFeatureKey('voice'), label: 'Voz' },
];

export const ACCESS_CONTROL_CATALOG = [
  // v91: Dashboard virou grupo com sub-páginas — cada uma controlável
  // individualmente (as keys batem com os `name` dos filhos na Sidebar.vue).
  {
    key: 'SegueDashboard',
    label: 'Dashboard (Segue)',
    children: [
      {
        key: 'SegueDashboard VisaoGeral',
        label: 'Visão Geral',
        routes: ['segue_dashboard', 'segue_dashboard_visao'],
      },
      { key: 'SegueDashboard Ofertas', label: 'Ofertas', routes: ['segue_dashboard_ofertas'] },
      { key: 'SegueDashboard Contratos', label: 'Contratos', routes: ['segue_dashboard_contratos'] },
      { key: 'SegueDashboard Equipe', label: 'Equipe', routes: ['segue_dashboard_equipe'] },
    ],
  },
  // v82: 'RealtimeReports' removido do catalogo (menu e rota /reports/live
  // apagados do sistema a pedido do Kairo 04/07/2026).
  {
    key: 'Inbox',
    label: 'Caixa de Notificações',
    routes: ['inbox_view', 'inbox_view_conversation'],
  },
  {
    key: 'Conversation',
    label: 'Conversas',
    children: [
      { key: 'All', label: 'Todas as Conversas', routes: ['home', 'inbox_conversation'] },
      {
        key: 'Mentions',
        label: 'Menções',
        routes: ['conversation_mentions', 'conversation_through_mentions'],
      },
      {
        key: 'Unattended',
        label: 'Não Atendidas',
        routes: ['conversation_unattended', 'conversation_through_unattended'],
      },
      {
        key: 'Folders',
        label: 'Pastas',
        routes: ['folder_conversations', 'conversations_through_folders'],
      },
      {
        key: 'Teams',
        label: 'Times',
        routes: ['team_conversations', 'conversations_through_team'],
      },
      {
        key: 'Channels',
        label: 'Canais',
        routes: ['inbox_dashboard', 'conversation_through_inbox'],
      },
      {
        key: 'Labels',
        label: 'Etiquetas',
        routes: ['label_conversations', 'conversations_through_label'],
      },
    ],
  },
  {
    key: 'Captain',
    label: 'Captain (IA)',
    routes: [
      'captain_assistants_index',
      'captain_assistants_responses_index',
      'captain_assistants_documents_index',
      'captain_tools_index',
      'captain_assistants_scenarios_index',
      'captain_assistants_playground_index',
      'captain_assistants_inboxes_index',
      'captain_assistants_responses_pending',
      'captain_assistants_settings_index',
      'captain_assistants_create_index',
    ],
  },
  { key: 'Kanban', label: 'Kanban', routes: ['kanban_index'] },
  // v105: funcionalidades FORA da sidebar, agora controlaveis por perfil.
  // Sem `routes` (nao sao telas): o gating e feito direto nos componentes
  // (Dashboard.vue -> ChatInterno). v107: a key 'Simulador' saiu junto com o
  // botao do simulador ANTIGO na conversa.
  { key: 'ChatInterno', label: 'Chat Interno (balão da equipe)' },
  // Aba "Fluxo IA" nas caixas de WhatsApp Cloud. SEM `routes` de proposito: a
  // rota settings_inbox_show e compartilhada por TODAS as abas da caixa —
  // registra-la aqui bloquearia a tela de caixas inteira. O gate e feito no
  // proprio Settings.vue. Nasce bloqueada para todos menos o id 1 (backfill).
  { key: 'Inbox Fluxo Whatsapp', label: 'Fluxo IA no WhatsApp (aba na caixa)' },
  // Mesma ideia para a aba do WEBCHAT ("Fluxo de atendimento" nas caixas de
  // site). Sem `routes` pelo mesmo motivo: settings_inbox_show e compartilhada.
  // O FILHO separa VER (aba visivel, so leitura) de CONFIGURAR (salvar). Como
  // key nova, nasce BLOQUEADA para nao-admin (getBlockedFeatureKeys abaixo) =>
  // o default do produto e read-only e liberar vira ato explicito na tela.
  // Cascata do toggleKey (Index.vue): desmarcou o pai => o filho cai junto
  // ("nao ve a aba => nao salva"). "Ve mas nao configura" = pai marcado +
  // filho desmarcado.
  // A autoridade real e o backend (MazamWebController#require_mazam_flow_config,
  // que roda DEPOIS do require_mazam_admin): mesmo com a aba visivel, quem
  // nao tem esta key toma 403 ao tentar salvar.
  {
    key: 'Inbox Fluxo Webchat',
    label: 'Fluxo de atendimento no Webchat (aba na caixa)',
    children: [
      {
        key: 'Inbox Fluxo Webchat Editar',
        label: 'Configurar/salvar o fluxo (sem isto, a aba fica só leitura)',
      },
    ],
  },
  // Task 5 (credenciais por caixa, 11/08/2026): aba "Credenciais dos Bancos"
  // dentro de Configurações da Caixa. Sem `routes` pelo mesmo motivo das duas
  // acima. Esta chave e so o gate de UI (esconder a aba) — a autoridade real e
  // o backend (Api::V1::Accounts::BankSettingsController#authorize_inbox!,
  // InboxPolicy#admin_or_member? por inbox_id): mesmo com a aba visivel,
  // quem nao e admin nem membro da caixa recebe 403 do servidor.
  { key: 'Inbox Credenciais Bancos', label: 'Credenciais dos Bancos (aba na caixa)' },
  // Tela de Credenciais e Chaves (OpenAI/Supabase/livres).
  // v112 (A2): a key batia com o rotulo da tela, mas o `name` REAL do item na
  // Sidebar.vue (~linha 836) sempre foi 'Settings Other Settings' -> bloqueio
  // salvo com a key antiga nunca escondia nada. Ver LEGACY_KEYS abaixo para a
  // migracao leve das blocklists ja salvas com a key errada.
  { key: 'Settings Other Settings', label: 'Credenciais e Chaves', routes: ['other_settings_index'] },
  // v106: telas portadas do MAZAM AI e Ranking de vendas. v107: a key
  // 'Simulador Menu' saiu junto com o item do menu e a rota simulador_index.
  { key: 'Simulacao Digitacao', label: 'Simulação e Digitação', routes: ['simulacao_digitacao_index'] },
  { key: 'Propostas', label: 'Propostas', routes: ['propostas_index'] },
  { key: 'Ranking', label: 'Ranking (pódium de vendas)', routes: ['ranking_index'] },
  // v109: WhatsApp Call (ligações pelo número oficial)
  {
    key: 'WhatsappCall',
    label: 'WhatsApp Call',
    children: [
      { key: 'WhatsappCall Dashboard', label: 'Dashboard de Ligações', routes: ['whatsapp_call_dashboard'] },
      { key: 'WhatsappCall Config', label: 'Configuração (chave geral)', routes: ['whatsapp_call_config'] },
    ],
  },
  {
    key: 'Contacts',
    label: 'Contatos',
    children: [
      {
        key: 'All Contacts',
        label: 'Todos os Contatos',
        routes: ['contacts_dashboard_index', 'contacts_edit'],
      },
      { key: 'Active', label: 'Ativos', routes: ['contacts_dashboard_active'] },
      {
        key: 'Segments',
        label: 'Segmentos',
        routes: ['contacts_dashboard_segments_index', 'contacts_edit_segment'],
      },
      {
        key: 'Tagged With',
        label: 'Por Etiqueta',
        routes: ['contacts_dashboard_labels_index', 'contacts_edit_label'],
      },
    ],
  },
  {
    key: 'Companies',
    label: 'Empresas',
    children: [
      { key: 'All Companies', label: 'Todas as Empresas', routes: ['companies_dashboard_index'] },
    ],
  },
  {
    key: 'Reports',
    label: 'Relatórios',
    children: [
      { key: 'Report Overview', label: 'Visão Geral', routes: ['account_overview_reports'] },
      { key: 'Report Conversation', label: 'Conversas', routes: ['conversation_reports'] },
      { key: 'Reports Agent', label: 'Agentes', routes: ['agent_reports_index', 'agent_reports_show'] },
      { key: 'Reports Label', label: 'Etiquetas', routes: ['label_reports_index'] },
      { key: 'Reports Inbox', label: 'Caixas', routes: ['inbox_reports_index', 'inbox_reports_show'] },
      { key: 'Reports Team', label: 'Times', routes: ['team_reports_index', 'team_reports_show'] },
      { key: 'Reports CSAT', label: 'CSAT', routes: ['csat_reports'] },
      { key: 'Reports SLA', label: 'SLA', routes: ['sla_reports'] },
      { key: 'Reports Bot', label: 'Bot', routes: ['bot_reports'] },
    ],
  },
  {
    key: 'Campaigns',
    label: 'Campanhas',
    children: [
      { key: 'Live chat', label: 'Live Chat', routes: ['campaigns_livechat_index'] },
      { key: 'SMS', label: 'SMS', routes: ['campaigns_sms_index'] },
      { key: 'WhatsApp', label: 'WhatsApp', routes: ['campaigns_whatsapp_index'] },
    ],
  },
  {
    key: 'Settings',
    label: 'Configurações',
    children: [
      { key: 'Settings Account Settings', label: 'Configurações da Conta', routes: ['general_settings_index'] },
      // v110: chave geral do chat interno
      { key: 'Settings Chat Interno', label: 'Chat Interno (liga/desliga)', routes: ['chat_interno_settings_index'] },
      { key: 'Settings Captain', label: 'Captain IA', routes: ['captain_settings_index'] },
      { key: 'Settings Agents', label: 'Agentes', routes: ['agent_list'] },
      {
        key: 'Settings Teams',
        label: 'Times',
        routes: [
          'settings_teams_list', 'settings_teams_new', 'settings_teams_finish',
          'settings_teams_add_agents', 'settings_teams_show', 'settings_teams_edit',
          'settings_teams_edit_members', 'settings_teams_edit_finish',
        ],
      },
      {
        key: 'Settings Agent Assignment',
        label: 'Atribuição de Agentes',
        routes: [
          'assignment_policy_index', 'agent_assignment_policy_index',
          'agent_assignment_policy_create', 'agent_assignment_policy_edit',
          'agent_capacity_policy_index', 'agent_capacity_policy_create',
          'agent_capacity_policy_edit',
        ],
      },
      {
        key: 'Settings Inboxes',
        label: 'Caixas de Entrada',
        routes: [
          'settings_inbox_list', 'settings_inbox_show', 'settings_inbox_new',
          'settings_inbox_finish', 'settings_inboxes_page_channel', 'settings_inboxes_add_agents',
        ],
        // Quais TIPOS DE CANAL o usuário enxerga na tela de criar caixa.
        // Desmarcado = o card some da tela dele e o acesso direto pela URL é
        // bloqueado. As keys batem com as do ChannelList/ChannelFactory.
        children: CHANNEL_KEYS,
      },
      { key: 'Settings Labels', label: 'Etiquetas', routes: ['labels_list'] },
      { key: 'Settings Custom Attributes', label: 'Atributos Personalizados', routes: ['attributes_list'] },
      { key: 'Settings Automation', label: 'Automação', routes: ['automation_list'] },
      { key: 'Settings Agent Bots', label: 'Agent Bots', routes: ['agent_bots'] },
      { key: 'Settings Macros', label: 'Macros', routes: ['macros_wrapper'] },
      { key: 'Settings Canned Responses', label: 'Respostas Prontas', routes: ['canned_list'] },
      { key: 'Settings Integrations', label: 'Integrações', routes: ['settings_applications'] },
      { key: 'Settings Audit Logs', label: 'Logs de Auditoria', routes: ['auditlogs_list'] },
      { key: 'Settings Custom Roles', label: 'Perfis Personalizados', routes: ['custom_roles_list'] },
      // Legado (Task 5, 11/08/2026): tela por CONTA sem link no menu desde
      // que a credencial virou por CAIXA (aba "Credenciais dos Bancos" em
      // Configurações da Caixa — chave 'Inbox Credenciais Bancos' acima).
      // Mantido no catálogo só pra quem quiser bloquear a URL antiga também.
      { key: 'Settings Bank Settings', label: 'Credenciais de Bancos (legado, sem menu)', routes: ['bank_settings_index'] },
      { key: 'Settings Sla', label: 'SLA', routes: ['sla_list'] },
      { key: 'Conversation Workflow', label: 'Fluxo de Conversas', routes: ['conversation_workflow_index'] },
      { key: 'Settings Security', label: 'Segurança', routes: ['security_settings_index'] },
      { key: 'Settings Billing', label: 'Faturamento', routes: ['billing_settings_index'] },
    ],
  },
];

// Mapa route name -> feature key (para o guard). So nos que possuem `routes`.
const buildRouteMap = () => {
  const map = {};
  const visit = nodes => {
    nodes.forEach(node => {
      (node.routes || []).forEach(routeName => {
        map[routeName] = node.key;
      });
      if (node.children) visit(node.children);
    });
  };
  visit(ACCESS_CONTROL_CATALOG);
  return map;
};

export const ROUTE_TO_FEATURE_KEY = buildRouteMap();

export const featureKeyForRouteName = routeName =>
  routeName ? ROUTE_TO_FEATURE_KEY[routeName] || null : null;

// v112 (A2): mapa de keys legadas -> key atual do catalogo. 'Credenciais
// Chaves' virou 'Settings Other Settings' porque a antiga nunca bateu com o
// `name` real do item na Sidebar (nunca escondia nada). Aplicado on-read aqui
// (blocklist E known_keys que o usuario ainda tenha salvos com a key velha) e
// on-read/on-write no controller (`controle_acesso_controller.rb`), para as
// blocklists ja salvas continuarem validas sem migracao em massa.
export const LEGACY_KEYS = {
  'Credenciais Chaves': 'Settings Other Settings',
};

const applyLegacyKeyMap = keys =>
  (Array.isArray(keys) ? keys : []).map(key => LEGACY_KEYS[key] || key);

// v112 (A3): keys que NUNCA entram no bloqueio AUTOMATICO de "feature nova
// nasce bloqueada" (getBlockedFeatureKeys abaixo), mesmo ausentes de
// ui_known_keys. Sao a base minima de navegacao (o grupo de Conversas e a
// aba "Todas as Conversas", que mapeia a rota `home` — landing page de todo
// usuario). Existe para nao trancar usuarios antigos fora do sistema caso o
// backfill documental (overlays/backfill_controle_acesso_known_keys.rb) nao
// tenha rodado ainda. So protege do bloqueio IMPLICITO: se a key estiver
// EXPLICITAMENTE na blocklist (usuario/admin marcou de proposito na tela),
// o bloqueio vale normalmente — esta lista nao filtra ui_blocklist.
// 13/08/2026 (regra do Kairo): "todo usuário integrado na caixa deve visualizar
// e EDITAR a caixa dele normalmente; só não pode se estiver DESMARCADO no
// Controle de Acesso". Por isso as keys da caixa entram aqui: elas NUNCA são
// auto-bloqueadas por omissão (feature nova) — só bloqueiam quando o admin
// desmarca EXPLICITAMENTE na tela (entra em ui_blocklist). O escopo por caixa
// (só a caixa onde ele é membro) continua valendo no servidor, sempre.
export const NUNCA_AUTO_BLOQUEAR = [
  'Conversation',
  'All',
  'Inbox Fluxo Webchat',
  'Inbox Fluxo Webchat Editar',
  'Inbox Fluxo Whatsapp',
  'Inbox Credenciais Bancos',
];

// Achata o catalogo (grupos + filhos + tipos de canal) e retorna todas as
// `key`. Fonte unica usada pelo front para mandar `known_keys` no save (A3,
// Index.vue) e aqui para calcular quais keys sao "novas" para o usuario.
export const flattenCatalogKeys = (nodes = ACCESS_CONTROL_CATALOG) => {
  const keys = [];
  const visit = list => {
    list.forEach(node => {
      keys.push(node.key);
      if (node.children) visit(node.children);
    });
  };
  visit(nodes);
  return keys;
};

// I3 (revisao final, 2026-08-12): admin (role 'administrator' na conta
// atual) NAO E MAIS totalmente isento -- isso era regressao introduzida pela
// A3 (isentava administradores de TUDO, inclusive blocklist EXPLICITA). Em
// producao ha admin com ui_blocklist configurada de proposito (o padrao do
// produto sempre foi "so o super admin id 1 nunca e restringido" -- ver
// docs/RBAC-controle-acesso.md#1). A isencao TOTAL agora e so pra
// `user.id === 1`; administrador comum ainda respeita a blocklist explicita,
// mas continua isento do bloqueio AUTOMATICO por omissao (feature nova fora
// de ui_known_keys) para nao trancar um admin so por causa do backfill nao
// ter rodado ainda para ele. Ver getBlockedFeatureKeys abaixo.
// O objeto `user` passado aqui e sempre o `getCurrentUser` do store
// (Sidebar.vue, Settings.vue, ChannelList.vue, ChannelFactory.vue) — tem
// `accounts: [{id, role, ...}]` e `account_id` (conta ativa). Nao existe um
// `.role` de topo nesse objeto (por isso nao dava pra so checar
// `user.role === 'administrator'`).
const isAdminUser = user => {
  if (!user || !Array.isArray(user.accounts)) return false;
  const current = user.accounts.find(acc => acc.id === user.account_id);
  return current?.role === 'administrator';
};

// Blocklist de UI do usuario (custom_attributes.ui_blocklist), acrescida das
// keys do catalogo que o usuario ainda NAO CONHECE (A3: feature nova nasce
// bloqueada para nao-admin, nao liberada por omissao).
// I3 (revisao final): SOMENTE o super admin (id 1) e totalmente isento
// (`[]`). Administrador comum (role 'administrator' != id 1) volta a
// respeitar a blocklist EXPLICITA (`ui_blocklist`, mapeada por
// LEGACY_KEYS) — mas NUNCA recebe o bloqueio AUTOMATICO de features novas
// (`newKeys`, calculado a partir de `ui_known_keys`): sem isso, um admin sem
// `ui_known_keys` salvo ficaria trancado do catalogo inteiro so por
// omissao, o que nao e a intencao (o auto-bloqueio existe pra proteger
// perfis restritos por padrao, nao admins).
export const getBlockedFeatureKeys = user => {
  if (!user) return [];
  if (user.id === 1) return [];

  const ca = user.custom_attributes || {};
  const blocklist = applyLegacyKeyMap(
    Array.isArray(ca.ui_blocklist) ? ca.ui_blocklist : []
  );

  if (isAdminUser(user)) return blocklist;

  const knownKeys = ca.ui_known_keys;
  if (!Array.isArray(knownKeys)) {
    // Usuario nunca re-salvo desde o deploy do ui_known_keys: fallback e o
    // comportamento antigo (so a blocklist), para nao bloquear tudo de
    // supetao sem config. O backfill documental cobre os supervisores atuais
    // (ver overlays/backfill_controle_acesso_known_keys.rb).
    return blocklist;
  }

  const known = applyLegacyKeyMap(knownKeys);
  const newKeys = flattenCatalogKeys().filter(
    key => !known.includes(key) && !NUNCA_AUTO_BLOQUEAR.includes(key)
  );
  return Array.from(new Set([...blocklist, ...newKeys]));
};

// Canais que o usuario PODE ver/criar na tela de nova caixa. Super admin ve
// todos. Canal so e escondido quando foi explicitamente desmarcado — quem nunca
// abriu o Controle de Acesso continua vendo tudo (nao quebra quem ja existe).
export const isChannelAllowed = (user, channelKey) => {
  const blocked = getBlockedFeatureKeys(user);
  if (!blocked.length) return true;
  return !blocked.includes(channelFeatureKey(channelKey));
};

// Remove recursivamente da arvore de menus os nos cuja key (name) esta bloqueada.
// v91: se TODOS os filhos de um grupo foram bloqueados e o grupo nao tem rota
// propria (`to`), o grupo some junto (evita header morto na Sidebar).
export const stripBlockedMenuItems = (items, blockedKeys = []) => {
  if (!blockedKeys.length) return items;
  return items
    .filter(item => !blockedKeys.includes(item.name))
    .map(item =>
      item.children
        ? { ...item, children: stripBlockedMenuItems(item.children, blockedKeys) }
        : item
    )
    .filter(item => !(Array.isArray(item.children) && item.children.length === 0 && !item.to));
};

// v52: primeira tela LIBERADA para o usuario (route name), percorrendo o
// catalogo na ordem do menu. Pula nos bloqueados (e seus filhos). Usado pelo
// guard (routeHelpers) como destino de aterrissagem quando a home/conversas
// esta bloqueada, evitando o loop de redirect "fica so carregando".
// Retorna null se NADA estiver liberado.
export const firstAllowedRouteName = user => {
  const blocked = getBlockedFeatureKeys(user);
  let found = null;
  const visit = nodes =>
    nodes.forEach(node => {
      if (found || blocked.includes(node.key)) return;
      if (node.routes && node.routes.length) {
        found = node.routes[0];
        return;
      }
      if (node.children) visit(node.children);
    });
  visit(ACCESS_CONTROL_CATALOG);
  return found;
};
